function addNextPageToPagination() {
    const nextPage = $("[data-testid='linkNextPage']")

    if (nextPage.length) {
        const newNextPage = nextPage.clone()
        const lastPage = $(".pagination [data-testid='linkLastPage']")
        const nextPageNum = parseInt($('.current').text()) + 1

        if (lastPage.attr('href') === nextPage.attr('href')) {
            return
        }

        newNextPage.removeClass('next pagination-link')
        newNextPage.insertAfter('.pagination .current')
        newNextPage.text(nextPageNum)
    }
}

function categoryTop() {
    // přesunout obrázek mimo category-perex
    $('.category-perex p:has(img)').last().prependTo('.category-top').addClass('category-image')
    $('.category-title').prependTo('.category-perex')
}

function addProductsBanner() {
    const productsBanner = $('.help-banner');
    const categoryContentWrapper = $('.category-content-wrapper');

    if (productsBanner.length && categoryContentWrapper.length) {
        categoryContentWrapper.append(productsBanner);
    }
}

function handleContentLoaded() {
    categoryTop()
    addNextPageToPagination()
    addProductsBanner()
}

export function initCategory() {
    handleContentLoaded()

    document.addEventListener('ShoptetDOMPageContentLoaded', async function () {
        handleContentLoaded()
    })

    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', () => {
        addNextPageToPagination()
    })
}
